import React, { useEffect, useRef, useState } from 'react';
import { useCommon } from "../context/CommonContext";
import { useNavigate } from "react-router-dom";
import { useLanguage } from '../context/LanguageProvider';


const IATTestv2a = () => {

    const { attributes, currentMemoryIndex, memories, iatTestReaction, intermissionText, kioskTimeoutText, prompts, questionID  } = useCommon();
    const {translation} = useLanguage();

    // List of words to display
    const WORDS = attributes[2].length == 0 ? ["Default-1", "Default-2", "Default-3","Default-4", "Default-5", "Default-6","Default-7", "Default-8", "Default-9"]: attributes[2];

    const config = {
        minReactionTime: 150,
        maxDisplayTime: 1000,
        delayBetweenWordsMin: 1000,
        delayBetweenWordsMax: 1500,
        noReactionTime: 1000,
        inactivityTime: 240000,
        breakTime: 10000,
        gameDelay: 1500,
        maxMissedResponses: Math.floor(WORDS.length/2),
        noofGames: 2,
        AditionalInitialWordDelay: 1500
    };

    console.log("--------------component rendered-------------");

    // State to track the current word being displayed
    const [currentWord, setCurrentWord] = useState("");

    // State to track if the game is over
    const [isGameOver, setIsGameOver] = useState(false);

    // State to track inactivity
    const [isInactive, setIsInactive] = useState(false);

    // State to manage the error messages
    const [errorOneMessage, setErrorOneMessage] = useState(false);
    const [errorTwoMessage, setErrorTwoMessage] = useState(false);
    const [errorThreeMessage, setErrorThreeMessage] = useState(false);

    // state to set break message
    const [isBreak , setIsBreak] = useState(false);

    const [canContinue, setCanContinue] = useState(false);
    const canContinue2 = useRef(false);

    // Refs to store mutable data
    const finalWordListRef = useRef([]); // Ref to store the final word list
    const wordIndexRef = useRef(0); // Tracks the index of the current word
    const startTimeRef = useRef(null); // Tracks when the current word was displayed
    // const reactionTimesRef = useRef([]); // Stores reaction times as [{ word, reactionTime, ... }, ...]
    const timerRef = useRef(null); // Stores the timeout for moving to the next word
    const isSpacePressedRef = useRef(false); // Prevents multiple spacebar presses
    const isPausedRef = useRef(false);  // State to track if the game is paused
    const missedResponsesRef = useRef(0); 
    const isTransitioningRef = useRef(false);
    const gamesPlayed = useRef(0);
    const isInitializedRef = useRef(false); // Ref to track if the game has been initialized
    const inactivityTimerRef = useRef(null); // Stores the inactivity timeout
    const displayNextWordTimerRef = useRef(null);
    const gameEnded = useRef(false);

    const navigate = useNavigate();


    // Helper functions
    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };


    const createFinalWordList = () => {
        const shuffledWords = shuffleArray([...WORDS]);
        const burnoutCount = 2;
        const randomIndex = Math.random() < 0.5 ? 3 : 4;
        const slicedWords = shuffledWords.slice(randomIndex);
        const burnoutWords = getRandomWords(slicedWords, burnoutCount);
        const finalList = [...burnoutWords, ...shuffledWords];
        finalWordListRef.current = finalList;
        console.log(`finalword list - ${finalWordListRef.current}`);
    };


    const getRandomWords = (array, count) => {
        const result = [];
        const seenIndices = new Set();

        while (result.length < count) {
            const randomIndex = Math.floor(Math.random() * array.length);
            if (!seenIndices.has(randomIndex)) {
                seenIndices.add(randomIndex);
                result.push(array[randomIndex]);
            }
        }

        return result;
    };


    useEffect(() => {
        console.log("--------------useEffect called-------------");
        let timeoutId; // Declare timeoutId in the outer scope
    
        const setCurrentWordWithDelay = () => {
            return new Promise((resolve) => {
                const initialDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin + config.AditionalInitialWordDelay);
                timeoutId = setTimeout(() => {
                    setCurrentWord(finalWordListRef.current[0]);
                    resolve(); // Resolve the promise after setting the current word
                }, initialDelay);
            });
        };
    
        const initializeGame = async () => {
            if (!isInitializedRef.current) {
                createFinalWordList();
                await setCurrentWordWithDelay(); // Wait for the current word to be set
                isInitializedRef.current = true; // Mark as initialized
            }
    
            missedResponsesRef.current = 0;
    
            // Add keydown event listener
            window.addEventListener('keydown', handleKeyPress);
            window.addEventListener('mousemove', resetInactivityTimer);
            resetInactivityTimer();
            console.log('Game started');
    
            // Record start time for the first word
            startTimeRef.current = performance.now();
            console.log(`Displaying word: ${finalWordListRef.current[wordIndexRef.current]}`);
    
            // Set timeout for the first word
            timerRef.current = setTimeout(() => {
                console.log(`No reaction for word: ${finalWordListRef.current[wordIndexRef.current]}`);
                isTransitioningRef.current = true;
                missedResponsesRef.current += 1;
                iatTestReaction.current.push([
                    finalWordListRef.current[wordIndexRef.current],
                    config.noReactionTime,
                    memories[currentMemoryIndex.current],
                    gamesPlayed.current,
                    wordIndexRef.current,
                    false, // No reaction
                    currentMemoryIndex.current+1,
                    questionID[2],
                ]);
                const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin);
                console.log(`random delay ${randomDelay}`);
                setCurrentWord("");
                displayNextWordTimerRef.current = setTimeout(() => {
                    displayNextWord();
                }, randomDelay);
            }, config.maxDisplayTime);
        };
    
        initializeGame(); // Call the async function
    
        // Cleanup on unmount
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
            window.removeEventListener('mousemove', resetInactivityTimer);
            clearTimeout(timerRef.current);
            clearTimeout(inactivityTimerRef.current);
            clearTimeout(timeoutId); // Clear the timeout if it exists
        };
    
    }, []); // Empty dependency array since this runs once on mount
    
    


    // Reset inactivity timer function
    const resetInactivityTimer = () => {
        setIsInactive(false);
        clearTimeout(inactivityTimerRef.current);
        inactivityTimerRef.current = setTimeout(() => {
            setIsInactive(true); // Show inactivity message after 4 minutes
        }, config.inactivityTime); // 4 minutes in milliseconds
    };


    // Function to start displaying the next word
    const displayNextWord = () => {

        console.log("--------------displayNextWord called-------------");

        const nextIndex = wordIndexRef.current + 1;

        if (nextIndex >= finalWordListRef.current.length) {
            // End the game when all words are shown
            setIsGameOver(true);
            gameEnded.current = true;
            console.log('Game Over. Reaction Times:', iatTestReaction.current);
            handleGameOver();
            return;
        }

        // Update the word and index
        wordIndexRef.current = nextIndex;
        setCurrentWord(finalWordListRef.current[nextIndex]);
        isTransitioningRef.current = false;

        // Reset spacebar press flag
        isSpacePressedRef.current = false;

        // Record the start time for the current word
        startTimeRef.current = performance.now();

        console.log(`Displaying word: ${finalWordListRef.current[wordIndexRef.current]}`);

        // Set a timeout to move to the next word after few seconds
        timerRef.current = setTimeout(() => {
            console.log(`No reaction for word: ${finalWordListRef.current[wordIndexRef.current]}`);
            setCurrentWord("");
            missedResponsesRef.current +=1;
            if (missedResponsesRef.current>config.maxMissedResponses) {
                const currentWord = finalWordListRef.current[wordIndexRef.current]; // Use the current word from WORDS array
                iatTestReaction.current.push([ 
                    currentWord, 
                    config.noReactionTime,
                    memories[currentMemoryIndex.current],
                    gamesPlayed.current,
                    wordIndexRef.current,
                    false, // missed
                    currentMemoryIndex.current+1,
                    questionID[2],
                  ]);
                isPausedRef.current = true;// Pause the game
                isSpacePressedRef.current = false;
                setErrorOneMessage(true);
            } else {
                isTransitioningRef.current = true;
                iatTestReaction.current.push([ 
                    finalWordListRef.current[wordIndexRef.current], 
                    config.noReactionTime,
                    memories[currentMemoryIndex.current],
                    gamesPlayed.current,
                    wordIndexRef.current,
                    false, // No reaction 
                    currentMemoryIndex.current+1,
                    questionID[2],
                ]);
                const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin);
                console.log(`random delay ${randomDelay}`);
                displayNextWordTimerRef.current = setTimeout(()=>{
                    displayNextWord();
                }, randomDelay)
            }
        }, config.maxDisplayTime);
    };


    // Handle game over logic
    const handleGameOver = () => {
        gamesPlayed.current += 1; // Increment the games played count
        if (gamesPlayed.current < config.noofGames) {
            // If this is the first game, restart after a 10-second break
            setIsBreak(true);
            isTransitioningRef.current = true;
            gameEnded.current = true;
            console.log("First game over. Starting break before the second game...");
            setTimeout(() => {
                // console.log("Starting second game...");
                // resetGame();
                setCanContinue(true);
                canContinue2.current = true;
            }, config.breakTime); // 10 seconds break
        } else {
            // If this is the second game, navigate to the thank-you page
            console.log("Second game over. Navigating to thank you page...");
            navigate('/IATTestThankYou');
        }
    };


    // Reset game state for a new game
    const resetGame = async () => {
        console.log("Resetting game for the next round...");
        setIsGameOver(false);
        const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin + config.AditionalInitialWordDelay);
        await new Promise((resolve) => setTimeout(resolve,randomDelay))
        isPausedRef.current = false;
        isSpacePressedRef.current = false;
        wordIndexRef.current = 0;
        missedResponsesRef.current = 0;
        createFinalWordList();
        isTransitioningRef.current = false;
        gameEnded.current = false;
        setCurrentWord(finalWordListRef.current[0]);
        startTimeRef.current = performance.now();
        timerRef.current = setTimeout(() => {
            console.log(`No reaction for word: ${finalWordListRef.current[wordIndexRef.current]}`);
            isTransitioningRef.current = true;
            missedResponsesRef.current +=1;
            iatTestReaction.current.push([ 
                finalWordListRef.current[wordIndexRef.current], 
                config.noReactionTime,
                memories[currentMemoryIndex.current],
                gamesPlayed.current,
                wordIndexRef.current,
                false, // No reaction 
                currentMemoryIndex.current+1,
                questionID[2],
            ]);
            const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin);
            console.log(`random delay ${randomDelay}`);
            setCurrentWord("");
            displayNextWordTimerRef.current = setTimeout(()=>{
                displayNextWord();
            }, randomDelay)
        }, config.maxDisplayTime);
    };


    // Handle spacebar press
    const handleKeyPress = (event) => {

        console.log("--------------handleKeyPress called-------------");

        resetInactivityTimer();

        if(event.code === 'Space' && canContinue2.current){
            canContinue2.current = false;
            setCanContinue(false);
            setIsBreak(false);
            setTimeout(() => {
                resetGame();
            }, config.gameDelay);
            return;
        }

        // console.log(`${!isGameOver} ${!isSpacePressedRef.current}`);
        if (event.code === 'Space' && !isSpacePressedRef.current && !isGameOver && !isTransitioningRef.current) {

            isSpacePressedRef.current = true; // Prevent multiple presses

            console.log("inside")

            // Check if the game is paused
            if (isPausedRef.current) {
                console.log("Resuming game...");
                setErrorOneMessage(false);
                setErrorTwoMessage(false);
                setErrorThreeMessage(false);
                missedResponsesRef.current= 0;
                isPausedRef.current = false; // Resume the game
                const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin);
                console.log(`random delay ${randomDelay}`);
                setCurrentWord("");
                displayNextWordTimerRef.current = setTimeout(()=>{
                    displayNextWord(); // Continue from where it left off
                }, randomDelay)
                return;
            }

            clearTimeout(timerRef.current); // Clear the timeout

            // Calculate reaction time
            const reactionTime = performance.now() - startTimeRef.current;
            const roundedReactionTime = Math.round(reactionTime * 100) / 100;

            // Check for too fast reaction
            if (reactionTime < config.minReactionTime) {
                console.log(`Reaction time too fast: ${reactionTime}ms. Pausing game.`);
                setCurrentWord("");
                isPausedRef.current = true;// Pause the game
                missedResponsesRef.current=0;
                isSpacePressedRef.current = false;
                setErrorTwoMessage(true);
                const currentWord = finalWordListRef.current[wordIndexRef.current]; // Use the current word from WORDS array
                iatTestReaction.current.push([ 
                    currentWord, 
                    roundedReactionTime,
                    memories[currentMemoryIndex.current],
                    gamesPlayed.current,
                    wordIndexRef.current,
                    true, // fast reaction
                    currentMemoryIndex.current+1,
                    questionID[2],
                  ]);
                return; // Exit to avoid further processing
            }

            const currentWord = finalWordListRef.current[wordIndexRef.current]; // Use the current word from WORDS array
            iatTestReaction.current.push([ 
                currentWord, 
                roundedReactionTime,
                memories[currentMemoryIndex.current],
                gamesPlayed.current,
                wordIndexRef.current,
                true, // No reaction
                currentMemoryIndex.current+1,
                questionID[2],
             ]);
            missedResponsesRef.current=0;
            console.log(`Reaction time for ${currentWord}: ${reactionTime}ms`);

            // Move to the next word
            const randomDelay = (Math.random() * (config.delayBetweenWordsMax - config.delayBetweenWordsMin) + config.delayBetweenWordsMin);
            console.log(`random delay ${randomDelay}`);
            isTransitioningRef.current = true;
            setCurrentWord("");
            displayNextWordTimerRef.current = setTimeout(()=>{
                displayNextWord();
            }, randomDelay)

        }else{    
            if(!gameEnded.current && event.code === 'Space'){
                console.log("pressed on space while transitioning between attributes")
                clearTimeout(displayNextWordTimerRef.current)
                clearTimeout(timerRef.current);
                setCurrentWord("");
                isPausedRef.current = true;// Pause the game
                missedResponsesRef.current=0;
                isSpacePressedRef.current = false;
                isTransitioningRef.current = false;
                setErrorThreeMessage(true);
            }
        }
    };


    // Render the game UI
    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 relative">
            {isGameOver ? (
                <div className="flex flex-col items-center justify-center">
                    {isBreak && <h2 className="text-4xl font-semibold mb-4">{translation("IAT_IntermissionText")}</h2>}
                    {canContinue && <h2 className="absolute bottom-20 text-4xl text-gray-800 mt-4">{translation("IAT_PressSpaceToContinue")}</h2>}
                    {/* <h2 className="text-xl font-semibold mb-4">This text and below details are currently used for testing purpose, will be removed in the final version</h2>
                    <h2>Reaction Times:</h2>
                    <ul>
                    {iatTestReaction.current.map((result, index) => (
                        <li key={index}>
                            Word: {result[0]} <br />
                            Reaction Time: { `${result[1]}ms`} <br />
                            Memory: {result[2]} <br />
                            Games Played: {result[3]} <br />
                            Current Index: {result[4]} <br />
                            User Reacted: {result[5]}
                        </li>
                    ))}
                    </ul> */}
                </div>
            ) : ( 
                <div>
                    <div className="fixed inset-0 flex flex-col items-center justify-center">
                    {!errorOneMessage && !errorTwoMessage && !errorThreeMessage && <h2 className="absolute transform -translate-y-16 text-2xl font-semibold text-gray-500">{prompts[2]}</h2>}
                        <h2 className="absolute top-1/2 transform -translate-y-1/2 text-6xl">{currentWord}</h2>
                    </div>

                    {errorOneMessage && (<div className="text-red-600 mb-8 text-left font-bold left-0 text-3xl">
                                            {translation("IAT_NoResponsesDetected")}
                                                 <h6 className="text-2xl text-gray-700 mb-4 mt-4 text-left w-full max-w-5xl">
                                                    {translation("IAT_NoResponsesMessage")}
                                                    <br/> {translation("IAT_RememberToPressSpace")}
                                                    <br/> {translation("IAT_ResponsesMonitored")}
                                                    <br/> {translation("IAT_PleasePressSpaceToContinue")}
                                                </h6>
                                        </div>)
                    }

                    {errorTwoMessage && (<div className="text-red-600 mb-8 text-left font-bold left-0 text-3xl">
                                            {translation("IAT_TooFastWarning")}
                                                 <h6 className="text-2xl text-gray-700 mb-4 mt-4 text-left w-full max-w-5xl">
                                                 {translation("IAT_TooFastMessage")}
                                                    <br/> {translation("IAT_ConsiderEachWord")}
                                                    <br/> {translation("IAT_ResponsesMonitoredFocus")}
                                                    <br/> {translation("IAT_PleasePressSpaceToContinue")}
                                                </h6>
                                        </div>)
                    }
                    {errorThreeMessage && (<div className="text-red-600 mb-8 text-left font-bold left-0 text-3xl">
                                            {translation("IAT_NoWordOnScreenWarning")}
                                                 <h6 className="text-2xl text-gray-700 mb-4 mt-4 text-left w-full max-w-5xl">
                                                  {translation("IAT_NoWordMessage")}
                                                    <br/> {translation("IAT_RespondWhenWordAppears")}
                                                    <br/> {translation("IAT_ResponsesMonitoredFocusAgain")}
                                                    <br/> {translation("IAT_PleasePressSpaceToContinue")}
                                                </h6>
                                        </div>)
                    }
                </div>
            )}
            {isInactive && (
                        <div className="fixed inset-0 flex items-center justify-center bg-yellow-200">
                            <p className="text-5xl font-bold">{kioskTimeoutText.current}</p>
                        </div>
            )}
        </div>
    );
};

export default IATTestv2a;
